import React, { useState, useLayoutEffect } from 'react'
import { CButton, CForm, CFormInput, CFormLabel, CFormSelect } from '@coreui/react';
import Swal from "sweetalert2";
import axios from 'axios';
import ReactLoading from 'react-loading';
// import Select from 'react-select'
import './Bebidas.css'

// Estilos de los botones para subir imagenes
let uploadLabelStyle = { display: 'inline-block', padding: '10px 15px', backgroundColor: 'rgb(118, 133, 161)', color: 'white', borderRadius: '5px', cursor: 'pointer', width: '200px', };
let previewStyle = { maxWidth: '50px', maxHeight: '50px', minWidth: '50px', minHeight: '50px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', };

// Componentes para subir imagenes
function FileInput({ id, label, onFile, preview }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
            <input type="file" style={{ display: 'none' }} id={id} onChange={(e) => onFile(e.target.files[0])} />
            <label htmlFor={id} style={uploadLabelStyle}><i className="fa-solid fa-cloud-arrow-up"></i> {label}</label>
            {preview && <img src={preview} alt="Preview" style={previewStyle} />}
        </div>
    );
}

function ImgInput({ route, editImg, label, handleFile, setImg, setPreviewImg, previewImg, setEditImg, infoEdit }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "1vw" }}>
            <span style={{ fontWeight: "bold", fontSize: "15px", }}>Imagen</span>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }} >
                {
                    editImg ?
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "2vw" }}>
                            <FileInput label={label} id="uploadImg" onFile={(file) => handleFile({ target: { files: [file] } }, setImg, setPreviewImg)} preview={previewImg} />
                            <CButton color="danger" variant='outline' onClick={() => setEditImg(false)}><i className="fa-solid fa-xmark"></i></CButton>
                        </div>
                        :
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "2vw" }}>
                            <img src={`https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/${route}${infoEdit._id}.jpg?${Date.now()}`} style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '10px' }} />
                            <CButton color="success" variant='outline' onClick={() => setEditImg(true)}><i className="fa-solid fa-pen"></i></CButton>
                        </div>
                }
            </div>
        </div>
    )
}

function Input({ label, value, valueOG, set }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', width: '30%' }}>
            <CFormLabel style={{ fontSize: '10px' }}>{label}</CFormLabel>
            <CFormInput
                placeholder={label}
                style={{ maxWidth: '400px' }}
                value={value}
                onChange={(e) => { set(e.target.value); }}
                onBlur={() => { if (!value.trim()) { set(valueOG); } }}
            />
        </div>
    )
}

function InputArray({ title, array, arrayOG, setArray }) {
    const canAdd = array?.length < 4;
    const canRemove = array?.length > 1;

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>{title}</span>
            </div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }}>
                {array?.map((valor, index) => {
                    const isLast = index === array.length - 1;

                    return (
                        <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                            <CFormInput placeholder={`${title} #${index + 1}`} value={valor}
                                onChange={e => {
                                    const nuevas = [...array]; nuevas[index] = e.target.value;
                                    setArray(nuevas);
                                }}
                                onBlur={() => { if (!valor.trim()) { const nuevas = [...array]; nuevas[index] = arrayOG[index]; setArray(nuevas); } }}
                                style={{ minWidth: "350px", maxWidth: "350px" }} />

                            {isLast && canAdd ? (
                                <CButton shape='rounded-pill' size="sm" color="success" onClick={() => setArray([...array, ""])}><i className="fa-solid fa-plus"></i></CButton>
                            ) : (
                                canRemove && (
                                    <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { const nuevas = [...array]; nuevas.splice(index, 1); setArray(nuevas); }}><i className="fa-solid fa-minus"></i></CButton>
                                )
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

function EditRedes({ infoEdit, set }) {
    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", }}>Redes sociales</span>
            </div>

            {/* Si no hay redes agregadas, puedo agregar con un botón */}
            {
                infoEdit.redes.length === 0 ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "15px", marginTop: "15px" }}>
                        <CButton shape='rounded-pill' size="sm" color="success" onClick={() => { let nuevas = [...infoEdit.redes]; nuevas.push({ "Red social nueva": "" }); set({ ...infoEdit, redes: nuevas }); }}>Agregar red social&nbsp;<i className="fa-solid fa-plus"></i></CButton>
                    </div>
                ) :
                    infoEdit.redes.map((item, index) => {
                        let key = Object.keys(item)[0]; // Ej: "instagram"
                        let value = item[key];          // Ej: "https://instagram.com"

                        return (
                            <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "15px", marginTop: "15px" }}>
                                <CFormInput
                                    placeholder={key.charAt(0).toUpperCase() + key.slice(1)} // Instagram, Facebook...
                                    value={value}
                                    onChange={(e) => {
                                        let nuevas = [...infoEdit.redes];
                                        nuevas[index] = { [key]: e.target.value };
                                        set({ ...infoEdit, redes: nuevas });
                                    }}
                                    style={{ minWidth: '250px', maxWidth: '250px' }}
                                />

                                {
                                    // si ya son 4 no se puede agregar mas, y todas se pueden eliminar
                                    infoEdit.redes.length > 4 ? null : (
                                        <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { let nuevas = [...infoEdit.redes]; nuevas.splice(index, 1); set({ ...infoEdit, redes: nuevas }); }}><i className="fa-solid fa-minus"></i></CButton>
                                    )
                                }

                                {
                                    // si estoy en la ultima y no son 4 puedo agregar
                                    index === infoEdit.redes.length - 1 && infoEdit.redes.length < 4 ? (
                                        <CButton shape='rounded-pill' size="sm" color="success" onClick={() => { let nuevas = [...infoEdit.redes]; nuevas.push({ [key]: "" }); set({ ...infoEdit, redes: nuevas }); }}><i className="fa-solid fa-plus"></i></CButton>
                                    ) : null
                                }

                            </div>
                        );
                    })
            }
        </>
    )
}

function EditTimesPromo({ infoEdit, set }) {
    const dias = [
        { value: 0, label: "Domingo" },
        { value: 1, label: "Lunes" },
        { value: 2, label: "Martes" },
        { value: 3, label: "Miércoles" },
        { value: 4, label: "Jueves" },
        { value: 5, label: "Viernes" },
        { value: 6, label: "Sábado" }
    ]

    const empty = { dia: 1, inicio: "09:00", fin: "17:00" }
    const times = infoEdit.timesPromo || []

    const handleChange = (index, field, value) => {
        let nuevas = [...times]
        nuevas[index] = { ...nuevas[index], [field]: value }
        set({ ...infoEdit, timesPromo: nuevas })
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>Horarios de Promoción</span>
            </div>

            {times.length === 0 ? (
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                    <CButton shape='rounded-pill' size="sm" color="success" onClick={() => set({ ...infoEdit, timesPromo: [{ ...empty }] })}>
                        Agregar horario&nbsp;<i className="fa-solid fa-plus"></i>
                    </CButton>
                </div>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    {times.map((horario, index) => {
                        const isLast = index === times.length - 1
                        const canAdd = times.length < 100
                        const canRemove = times.length > 1

                        return (
                            <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>

                                <CFormSelect
                                    value={horario.dia}
                                    onChange={e => handleChange(index, "dia", Number(e.target.value))}
                                    style={{ minWidth: "140px", maxWidth: "140px" }}
                                >
                                    {dias.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                                </CFormSelect>

                                <CFormInput type="time" value={horario.inicio} onChange={e => handleChange(index, "inicio", e.target.value)} style={{ minWidth: "130px", maxWidth: "130px" }} />

                                <span style={{ fontWeight: "bold" }}>a</span>

                                <CFormInput type="time" value={horario.fin} onChange={e => handleChange(index, "fin", e.target.value)} style={{ minWidth: "130px", maxWidth: "130px" }} />

                                {isLast && canAdd ? (
                                    <CButton shape='rounded-pill' size="sm" color="success" onClick={() => set({ ...infoEdit, timesPromo: [...times, { ...empty }] })}>
                                        <i className="fa-solid fa-plus"></i>
                                    </CButton>
                                ) : canRemove && (
                                    <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { let nuevas = [...times]; nuevas.splice(index, 1); set({ ...infoEdit, timesPromo: nuevas }) }}>
                                        <i className="fa-solid fa-minus"></i>
                                    </CButton>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}
        </>
    )
}

function EditBanners({ banners, setBanners, nuevosArchivos, setNuevosArchivos, previews, setPreviews }) {
    const MAX = 4

    const handleFile = (e, index) => {
        let file = e.target.files[0]
        if (!file) return
        let tempArchivos = [...nuevosArchivos]
        let tempPreviews = [...previews]
        tempArchivos[index] = file
        tempPreviews[index] = URL.createObjectURL(file)
        setNuevosArchivos(tempArchivos)
        setPreviews(tempPreviews)
    }

    const eliminar = (index) => {
        let newBanners = [...banners]; newBanners.splice(index, 1)
        let newArchivos = [...nuevosArchivos]; newArchivos.splice(index, 1)
        let newPreviews = [...previews]; newPreviews.splice(index, 1)
        setBanners(newBanners)
        setNuevosArchivos(newArchivos)
        setPreviews(newPreviews)
    }

    const agregar = (e) => {
        let file = e.target.files[0]
        if (!file) return
        setBanners([...banners, null]) // placeholder
        setNuevosArchivos([...nuevosArchivos, file])
        setPreviews([...previews, URL.createObjectURL(file)])
    }

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>Banners</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                {banners.map((url, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <img src={previews[index] || url} style={previewStyle} />
                        <input type="file" accept=".jpg,image/jpeg" id={`edit-banner-${index}`} style={{ display: "none" }}
                            onChange={e => handleFile(e, index)} />
                        <label htmlFor={`edit-banner-${index}`} style={uploadLabelStyle}>
                            <i className="fa-solid fa-pen"></i> Banner {index + 1}
                        </label>
                        <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => eliminar(index)}>
                            <i className="fa-solid fa-minus"></i>
                        </CButton>
                    </div>
                ))}
                {banners.length < MAX && (
                    <>
                        <input type="file" accept=".jpg,image/jpeg" id="edit-banner-new" style={{ display: "none" }}
                            onChange={agregar} />
                        <label htmlFor="edit-banner-new" style={{ ...uploadLabelStyle, textAlign: 'center' }}>
                            <i className="fa-solid fa-plus"></i> Agregar banner
                        </label>
                    </>
                )}
            </div>
        </>
    )
}

function EditPDF({ infoEdit, menuPDF, setMenuPDF }) {
    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>Menú PDF</span>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>

                {/* PDF actual */}
                {infoEdit.menuPDF && !menuPDF && (
                    <a href={infoEdit.menuPDF} target="_blank" rel="noreferrer"
                        style={{ fontSize: "13px", color: "cornflowerblue" }}>
                        <i className="fa-solid fa-file-pdf"></i> Ver menú actual
                    </a>
                )}

                {/* Input para nuevo PDF */}
                <input type="file" accept=".pdf,application/pdf" id="editPDF" style={{ display: "none" }}
                    onChange={(e) => setMenuPDF(e.target.files[0])} />
                <label htmlFor="editPDF" style={uploadLabelStyle}>
                    <i className="fa-solid fa-file-pdf"></i> {infoEdit.menuPDF ? 'Cambiar PDF' : 'Subir menú PDF'}
                </label>

                {/* Preview del nuevo archivo */}
                {menuPDF && (
                    <>
                        <span style={{ fontSize: "13px", color: "gray" }}>{menuPDF.name}</span>
                        <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => setMenuPDF(null)}>
                            <i className="fa-solid fa-xmark"></i>
                        </CButton>
                    </>
                )}
            </div>
        </>
    )
}

function EditRestaurante({ setVisible2, infoEditOG, infoEdit, setInfoEdit, arrayContiene, setArrayContiene, arrayContieneOG, setArrayContieneOG, portalRestaurante }) {
    let [loading, setLoading] = useState(false);
    let [progress, setProgress] = useState(0); // Porcentaje de carga a cloudinary

    let [drinks, setDrinks] = useState([]);
    let [drinksUse, setDrinksUse] = useState([]);

    // En las imagenes que se van a editar hay que hace estos 3 estados por cada imagen
    let [previewLogo, setPreviewLogo] = useState(null); // Previsualizar la imagen original
    let [logo, setLogo] = useState(null); // Imagen que se va a subir en la edicion
    let [editLogo, setEditLogo] = useState(false); // Si se va a editar la imagen o no
    let folderLogo = `bebbo/logo` // Carpeta de cloudinary donde se subiran las imagenes

    let [previewImg, setPreviewImg] = useState(null);
    let [img, setImg] = useState(null);
    let [editImg, setEditImg] = useState(false);
    let folderImg = `bebbo/restaurante`

    let [nuevosArchivos, setNuevosArchivos] = useState([]) // archivos File nuevos
    let [previews, setPreviews] = useState([])
    let [menuPDF, setMenuPDF] = useState(null)

    // Función para identificar la red social
    function identificarRedSocial(url) {
        if (/instagram\.com/.test(url)) return "instagram";
        if (/facebook\.com/.test(url)) return "facebook";
        if (/x\.com|twitter\.com/.test(url)) return "x";
        if (/youtube\.com|youtu\.be/.test(url)) return "youtube";
        return "unknown";
    }

    // Función para manejar las imágenes y previsualizar
    function handleFile(e, setter, setPreview) {
        let file = e.target.files[0];
        setter(file); // Actualizar el estado con el archivo seleccionado
        if (file) setPreview(URL.createObjectURL(file));
    }

    // Funciones de validación
    function validarTel(tel) {
        return /^[0-9]{10,}$/.test(tel); // 10 o más dígitos
    }

    function validarCorreo(correo) {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(correo); // Correo electronico
    }

    function validarWhatsapp(whatsapp) {
        return /^[0-9]{10,}$/.test(whatsapp); // 10 o más dígitos
    }

    function validarURL(url) {
        return /^https?:\/\/.+/.test(url); // http:// o https://
    }

    function validarLatLong(ll) {
        return /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(ll); // 19.4326,-99.1332
    }

    function validarFormulario() {
        if (!validarTel(infoEdit.tel)) {
            Swal.fire({
                icon: "error",
                title: "Verifica tu teléfono",
                text: "El teléfono debe tener 10 o más dígitos.",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        if (!validarCorreo(infoEdit.email)) {
            Swal.fire({
                icon: "error",
                title: "Verifica tu correo",
                text: "El correo debe ser un correo electronico.",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        if (!validarWhatsapp(infoEdit.whatsapp)) {
            Swal.fire({
                icon: "error",
                title: "Verifica tu whatsapp",
                text: "El whatsapp debe tener 10 o más dígitos.",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        if (!validarURL(infoEdit.googleMapsURL)) {
            Swal.fire({
                icon: "error",
                title: "Verifica tu URL",
                text: "La URL debe ser http:// o https://",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        if (!validarLatLong(infoEdit.latLong)) {
            Swal.fire({
                icon: "error",
                title: "Verifica tus coordenadas",
                text: "Las coordenadas deben ser de la forma 19.4326,-99.1332",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        return !validarTel(infoEdit.tel) || !validarWhatsapp(infoEdit.whatsapp) || !validarURL(infoEdit.googleMapsURL) || !validarLatLong(infoEdit.latLong) || !validarCorreo(infoEdit.email)

    }

    // Función para validar el tipo y tamaño de la imagen
    function validarImagen(imagen) {
        if ((imagen.type !== "image/jpeg") || imagen.size > 400000) { // si el archivo pesa mas de 400kb y es tipo diferente a .jpg
            Swal.fire({
                icon: "error",
                title: "Verifica tu imagen",
                text: "Solo se permiten imágenes tipo .jpg y máximo de 400kb.",
                footer: `Esta es de tipo .${imagen.type.split("/")[1]} y pesa ${(imagen.size / 1024).toFixed(2)}kb.`,
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
            return false;
        }
        return true;
    }

    // Función para subir la imagen a cloudinary
    async function subirImagenACloudinary(archivo, nombreImagen, folder, tags) {
        if (!(validarImagen(archivo))) { // si la imagen es inválida
            throw new Error("Imagen inválida");
        }

        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = URL.createObjectURL(archivo);

            img.onload = async () => {
                if (false) {
                    // if (img.width < 300 || img.height < 300) { // si la imagen mide mínimo 300x300
                    Swal.fire(`La imagen debe medir mínimo 300x300px. Esta tiene ${img.width}x${img.height}`);
                    reject();
                } else {
                    let formData = new FormData();
                    formData.append("file", archivo);
                    formData.append("upload_preset", "upload_bebbo_restaurante");
                    formData.append("user", tags);
                    formData.append("folder", folder);
                    formData.append("public_id", nombreImagen);

                    try {
                        let res = await axios.post(`${process.env.REACT_APP_BackURL}/upMedia`, formData,
                            {
                                onUploadProgress: (e) => {
                                    let percent = Math.round((e.loaded * 100) / e.total);
                                    setProgress(percent);
                                }
                            }
                        );
                        resolve(res.data.secure_url);
                    } catch (err) {
                        reject(err);
                    }
                }
            };
        });
    };

    async function subirPDFADrive(archivo, nombreArchivo) {
        if (archivo.type !== 'application/pdf') {
            Swal.fire({ icon: "error", title: "Archivo inválido", text: "Solo se permiten archivos PDF." })
            throw new Error("Archivo inválido")
        }

        let formData = new FormData()
        formData.append("file", archivo)
        formData.append("public_id", nombreArchivo)

        let res = await axios.post(`${process.env.REACT_APP_BackURL}/uppdf`, formData, {
            onUploadProgress: (e) => {
                let percent = Math.round((e.loaded * 100) / e.total)
                setProgress(percent)
            }
        })
        return res.data.url
    }

    async function handleUpdate() {

        // Validar formulario
        if (validarFormulario()) return;

        try {

            setLoading(true);

            // CLONAR objeto para no mutar state directamente
            let updatedInfoEdit = { ...infoEdit };

            let nuevoLogo = logo ? await subirImagenACloudinary(logo, `logo${infoEdit._id}`, folderLogo, infoEditOG._id) : null;
            let nuevaImg = img ? await subirImagenACloudinary(img, `banner${infoEdit._id}`, folderImg, infoEditOG._id) : null;

            // Si cambio la imagen o el logo, actualizar el objeto
            if (nuevoLogo) updatedInfoEdit.logo = nuevoLogo;
            if (nuevaImg) updatedInfoEdit.img = nuevaImg;

            if (menuPDF) {
                let pdfUrl = await subirPDFADrive(menuPDF, `menu${infoEdit._id}`)
                updatedInfoEdit.menuPDF = pdfUrl
            }

            let bannersUrls = [...(updatedInfoEdit.banners || [])]
            for (let i = 0; i < nuevosArchivos.length; i++) {
                if (nuevosArchivos[i]) {
                    let url = await subirImagenACloudinary(nuevosArchivos[i], `banner${infoEdit._id}_${i}`, folderImg, infoEdit._id)
                    bannersUrls[i] = url
                }
            }
            if (JSON.stringify(bannersUrls) !== JSON.stringify(infoEditOG.banners || [])) {
                updatedInfoEdit.banners = bannersUrls.filter(Boolean)
            }
            // Convertir redes a un array
            if (Array.isArray(updatedInfoEdit.redes)) {
                let nuevasRedes = updatedInfoEdit.redes.map((obj) => {
                    let key = Object.keys(obj)[0] // Extraer la key
                    let url = obj[key]; // Extraer el value
                    let nuevaKey = identificarRedSocial(url); // Identificar la red social
                    return (nuevaKey && url.trim() !== "") ? { [nuevaKey]: url } : null; // si la red social es valida y la url no esta vacia agregarla al array, si no devuelve null
                }).filter(Boolean); // Filtrar los null
                updatedInfoEdit.redes = nuevasRedes; // Actualizar el array
            }

            let cambios = {};

            Object.keys(updatedInfoEdit).forEach((key) => {
                if (key === "redes") {
                    let original = infoEditOG.redes || [];
                    let editado = updatedInfoEdit.redes || [];

                    // Filtra claves vacías ("") del array editado
                    let editadoFiltrado = editado.map((obj) => {
                        let k = Object.keys(obj)[0];
                        let v = obj[k];
                        return v.trim() === "" ? null : { [k]: v };
                    }).filter(Boolean); // Filtrar los null

                    let originalFiltrado = original.filter((obj) => {
                        let k = Object.keys(obj)[0];
                        let v = obj[k];
                        return v.trim() !== "";
                    });

                    // Verifica si las redes han cambiado
                    let redesCambiaron =
                        originalFiltrado.length !== editadoFiltrado.length ||
                        originalFiltrado.some((obj, index) => {
                            let keyOriginal = Object.keys(obj)[0];
                            let keyEditado = Object.keys(editadoFiltrado[index] || {})[0];
                            let valOriginal = obj[keyOriginal];
                            let valEditado = editadoFiltrado[index]?.[keyEditado];
                            return keyOriginal !== keyEditado || valOriginal !== valEditado;
                        });

                    // Si las redes han cambiado, agregarlas al objeto de cambios
                    if (redesCambiaron) { cambios.redes = editadoFiltrado; }

                }
                else if (Array.isArray(updatedInfoEdit[key])) {
                    if (JSON.stringify(updatedInfoEdit[key]) !== JSON.stringify(infoEditOG[key])) {
                        cambios[key] = updatedInfoEdit[key];
                    }
                }
                else if (typeof updatedInfoEdit[key] === "object" && updatedInfoEdit[key] !== null) {
                    if (JSON.stringify(updatedInfoEdit[key]) !== JSON.stringify(infoEditOG[key])) {
                        cambios[key] = updatedInfoEdit[key];
                    }
                }
                else if (updatedInfoEdit[key] !== infoEditOG[key]) { cambios[key] = updatedInfoEdit[key]; }
            });

            if (Object.keys(cambios).length === 0 && !editLogo && !editImg && !nuevosArchivos.length && !menuPDF) {
                // console.log("No hay cambios");

                Swal.fire({
                    icon: 'info',
                    title: 'Sin cambios',
                    text: 'No hiciste ninguna modificación.',
                    confirmButtonColor: 'rgb(118, 133, 161)',
                }).then((result) => {

                    if (result.isConfirmed) {
                        setVisible2(false);
                    }
                });

            } else {
                // console.log("Cambios detectados:", cambios);

                let res = await axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${infoEdit._id}`, cambios);

                if (res.status === 200) {

                    Swal.fire({
                        icon: 'success',
                        title: 'Restaurante actualizado',
                        text: 'Los cambios se han guardado correctamente.',
                        confirmButtonColor: 'rgb(118, 133, 161)',
                    });
                }

                if (!portalRestaurante) {

                    let tempArrayContiene = [...arrayContiene];

                    let indexEdit = tempArrayContiene.findIndex(
                        (item) => item._id === infoEdit._id
                    );

                    if (indexEdit !== -1) {
                        tempArrayContiene[indexEdit] = updatedInfoEdit;
                    }

                    setArrayContiene(tempArrayContiene);

                    let tempArrayContieneOG = [...arrayContieneOG];

                    let indexEditOG = tempArrayContieneOG.findIndex((item) => item._id === infoEdit._id);

                    if (indexEditOG !== -1) { tempArrayContieneOG[indexEditOG] = updatedInfoEdit; }

                    setArrayContieneOG(tempArrayContieneOG);
                }

                setVisible2(false);
            }

        } catch (error) {
            // console.log(error);

            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: `Lo sentimos esta acción no se pudo completar. ${error}`,
                allowEscapeKey: true
            });

        } finally {
            setLoading(false);
        }
    }

    function getBebidas() {
        axios.get(`${process.env.REACT_APP_BackURL}/getAllDrinks`)
            .then((response) => {
                let temp = []
                response.data.data.forEach((drink) => { temp.push({ value: drink._id, label: `${drink.name.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}` }) })
                setDrinks(temp);
                setDrinksUse(response.data.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }

    useLayoutEffect(() => {
        getBebidas();
    }, []);

    return (
        <>
            <CForm>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    <Input label="Nombre" value={infoEdit.name} valueOG={infoEditOG.name} set={name => setInfoEdit({ ...infoEdit, name })} />
                    <Input label="Palabras para busqueda o filtros" value={infoEdit.type} valueOG={infoEditOG.type} set={type => setInfoEdit({ ...infoEdit, type })} />
                    <Input label="Dirección" value={infoEdit.address} valueOG={infoEditOG.address} set={address => setInfoEdit({ ...infoEdit, address })} />
                    <Input label="Teléfono" value={infoEdit.tel} valueOG={infoEditOG.tel} set={tel => setInfoEdit({ ...infoEdit, tel })} />
                    <Input label="Correo" value={infoEdit.email} valueOG={infoEditOG.email} set={email => setInfoEdit({ ...infoEdit, email })} />
                    <Input label="WhatsApp" value={infoEdit.whatsapp} valueOG={infoEditOG.whatsapp} set={whatsapp => setInfoEdit({ ...infoEdit, whatsapp })} />
                    <Input label="Descripción del restaurante" value={infoEdit.condiciones} valueOG={infoEditOG.condiciones} set={condiciones => setInfoEdit({ ...infoEdit, condiciones })} />
                    <Input label="Condiciones de uso" value={infoEdit.condiciones2} valueOG={infoEditOG.condiciones2} set={condiciones2 => setInfoEdit({ ...infoEdit, condiciones2 })} />
                    <Input label="Google Maps URL" value={infoEdit.googleMapsURL} valueOG={infoEditOG.googleMapsURL} set={googleMapsURL => setInfoEdit({ ...infoEdit, googleMapsURL })} />
                    <Input label="Latitud,Longitud" value={infoEdit.latLong} valueOG={infoEditOG.latLong} set={latLong => setInfoEdit({ ...infoEdit, latLong })} />

                    {/* <div>
                        <h6 style={{ textAlign: 'center' }}>Agregar bebidas</h6>
                        <Select className='select' placeholder="Buscar bebidas" options={drinks} onChange={(e) => {
                            let bebida = drinksUse.find((d) => d._id === e.value);
                            setInfoEdit({ ...infoEdit, drinks: [...infoEdit.drinks, bebida] });
                        }} />
                    </div> */}

                </div>

                {/* <div style={{ maxWidth: "400px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "8px", marginTop: "16px", }}>
                    {infoEdit.drinks.map((drink) => {
                        return (
                            <div key={drink.value} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", border: "1px solid #e4e6eb", borderRadius: "8px", backgroundColor: "#f8f9fa" }}>
                                <span>{drink.name}</span>
                                <CButton shape="rounded-pill" size="sm" color="danger" onClick={(d) => { setInfoEdit({ ...infoEdit, drinks: infoEdit.drinks.filter((d) => d._id !== drink._id) }); }}><i className="fa-solid fa-minus"></i></CButton>
                            </div>
                        );

                    })}
                </div> */}

                <InputArray title={"Horario"} array={infoEdit.times} arrayOG={infoEditOG.times} setArray={times => setInfoEdit({ ...infoEdit, times })} />

                <EditTimesPromo infoEdit={infoEdit} set={setInfoEdit} />

                <EditRedes infoEdit={infoEdit} set={setInfoEdit} />

                <EditBanners banners={infoEdit.banners || []} setBanners={(banners) => setInfoEdit({ ...infoEdit, banners })} nuevosArchivos={nuevosArchivos} setNuevosArchivos={setNuevosArchivos} previews={previews} setPreviews={setPreviews} />

                <EditPDF infoEdit={infoEdit} menuPDF={menuPDF} setMenuPDF={setMenuPDF} />

                <br />

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "2vw" }}>

                    {/* Imagen principal o banner */}
                    <ImgInput route='bebbo/restaurante/banner' editImg={editImg} label="Imagen del lugar" handleFile={handleFile} setImg={setImg} setPreviewImg={setPreviewImg} previewImg={previewImg} setEditImg={setEditImg} infoEdit={infoEdit} />


                    {/* Logo */}
                    <ImgInput route='bebbo/logo/logo' editImg={editLogo} label="Logo" handleFile={handleFile} setImg={setLogo} setPreviewImg={setPreviewLogo} previewImg={previewLogo} setEditImg={setEditLogo} infoEdit={infoEdit} />

                </div>

                <span style={{ fontWeight: "bold", fontSize: "15px", display: "flex", justifyContent: "center", marginTop: "10px" }}>La imágenes deben ser tipo .jpg y máximo 400kb</span>

            </CForm>

            <br />

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
                    <ReactLoading type="spin" color="cornflowerblue" height={'3vw'} width={'3vw'} />
                    <p style={{ fontSize: '2vw', color: 'cornflowerblue' }}>{progress}%</p>
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <CButton color="danger" onClick={() => setVisible2(false)}>Cancelar</CButton>
                    <CButton color="success" onClick={handleUpdate}>Actualizar</CButton>
                </div>
            )}
        </>
    )
}

export default EditRestaurante
